import asyncComponent from '../../components/AsyncComponent';

const HandbookPreview = asyncComponent(() => import('../../containers/Handbook/Preview'));

export default HandbookPreview;
